export default __webpack_public_path__ + "static/media/pk-jk.ffba0021.svg";